import PipelineFunded from './Charts/pipelineFunded';
import Leaderboards from './Charts/leaderboards';
// ...import additional charts

const chartMap = {
  'pipe-fund-summary': PipelineFunded,
  'partner-leaderboard': Leaderboards,
  // ...add more mappings as needed
};

export default function ReportChart({ reportType, data, filters }) {
  const ChartComponent = chartMap[reportType];

  if (!ChartComponent) {
    return <div className="text-muted">No chart available for this report.</div>;
  }

  return <ChartComponent data={data} filters={filters} />;
}